export const MAX_MESSAGE_LENGTH = 4000;
export const MIN_SPLITTABLE_MARKDOWN_LENGTH = 1229;

export const DEFAULT_LIMIT_OF_MESSAGES_LOADING = 100;
